import { useSearchParams } from "react-router-dom";
import { DocumentRecords } from "@components/Records/DocumentRecords";
import { VendorRecords } from "@components/Records/VendorRecords";
import { APPostingsPage } from "./APPostingsPage";
import { useRecordTabs } from "@/lib/recordCatalog";

const isLegacyDocumentType = (value: string | null) =>
  value === "invoice" || value === "receipt" || value === "purchase_order";

export function RecordsPage() {
  const [params, setParams] = useSearchParams();
  const tabs = useRecordTabs();
  const requested = params.get("type");
  const selected = isLegacyDocumentType(requested)
    ? "documents"
    : (requested ?? tabs[0]?.id);
  const allowed = tabs.some((tab) => tab.id === selected);
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold text-content-primary">Records</h1>
        <p className="text-content-secondary">
          Browse documents, accounting entries and vendors across all statuses.
        </p>
      </header>
      <nav aria-label="Record types" className="flex flex-wrap gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            aria-pressed={selected === tab.id}
            className={`rounded-lg border px-4 py-2 text-sm ${selected === tab.id ? "border-primary-500 bg-primary-50 text-primary-700" : "border-border-default text-content-secondary"}`}
            onClick={() => setParams({ type: tab.id })}
          >
            {tab.label}
          </button>
        ))}
      </nav>
      {!allowed ? (
        <p role="status">
          This record type is not available for your permissions or plan.
        </p>
      ) : (
        <section key={selected} aria-label="Record list">
          {selected === "documents" && <DocumentRecords />}
          {selected === "ap_posting" && <APPostingsPage />}
          {selected === "vendor" && <VendorRecords />}
        </section>
      )}
    </div>
  );
}
